var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30.8486 44.8612C38.2427 41.2319 43.2386 33.5859 43.1041 24.7644C43.0393 20.5173 41.771 16.562 39.6252 13.2246C45.6119 15.6003 49.8641 21.3692 49.9971 28.2386C50.023 29.5789 49.8891 30.8835 49.6131 32.1349C49.1457 34.2537 48.8679 45.0665 48.8679 45.0665C48.8679 45.0665 34.5096 45.0925 33.1692 45.0665C32.38 45.0512 31.6053 44.9816 30.8486 44.8612Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.00384 24.7082C1.21927 13.5865 10.2973 4.83251 21.4198 5.00243C32.2758 5.16815 41.0452 13.9377 41.2108 24.7938C41.3803 35.9161 32.6263 44.9938 21.5048 45.2092C19.8721 45.2408 2.37962 45.2092 2.37962 45.2092C2.37962 45.2092 2.04115 32.0361 1.47181 29.4549C1.13548 27.9305 0.972301 26.3409 1.00384 24.7082ZM10.4734 28.8605C12.3918 28.8605 13.9469 27.3054 13.9469 25.3871C13.9469 23.4688 12.3918 21.9137 10.4734 21.9137C8.55514 21.9137 7.00004 23.4688 7.00004 25.3871C7.00004 27.3054 8.55514 28.8605 10.4734 28.8605ZM24.3671 25.3871C24.3671 27.3054 22.812 28.8605 20.8937 28.8605C18.9754 28.8605 17.4203 27.3054 17.4203 25.3871C17.4203 23.4688 18.9754 21.9137 20.8937 21.9137C22.812 21.9137 24.3671 23.4688 24.3671 25.3871ZM31.3139 28.8605C33.2322 28.8605 34.7873 27.3054 34.7873 25.3871C34.7873 23.4688 33.2322 21.9137 31.3139 21.9137C29.3956 21.9137 27.8405 23.4688 27.8405 25.3871C27.8405 27.3054 29.3956 28.8605 31.3139 28.8605Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.47edc087c1a754fd0e081a9fb3cb8681.svg";
export { ForwardRef as ReactComponent };